  // these are creds for bunny
export const bunnySettings = {
    apiKey: '949465c3-24d6-4743-9d91f46d749a-33d3-4b6d',
    storageZoneName: 'filmid',
    library: '706667',
    endpoint: 'https://video.bunnycdn.com/',
    get libraryEndpoint() {
      return this.endpoint + 'library/' + this.library + '/';
    },
    get videoLibraryEndpoint() {
      return this.libraryEndpoint + 'videos/';
    },
    get header() {
      return {
        'AccessKey': this.apiKey,
      };
    }

  };